import {Subject} from "@/model/subject";
import {ResolveMessages} from "@/model/resolve-messages";
import moment from "moment";
import {CriteriaType, FilterCriteria} from "@/model/filter-criteria";

export class Message {
  id?: number;
  userId = '';
  name = '';
  phone = '';
  subject?: Subject;
  email = '';
  message = '';
  creationDate: Date = new Date();
  msisdn = '';
  state = '';
  resolveMessages: ResolveMessages[] = [];

  get prettyCreationDate() {
    return moment(this.creationDate).format('D/MM/YYYY, h:mm a');
  }
}

export class MessageFilter {
  dateFrom= '';
  dateTo= '';
  userId= '';
  name= '';
  phone= '';
  subject= '';
  email= '';
  message= '';
  msisdn= '';
  state= '';
  brand= '';

  static fromCriteria(c: FilterCriteria) {
    if(c.type === CriteriaType.MSISDN) {
      return new MessageFilter().withMsisdn(c.value);
    }
    if(c.type === CriteriaType.USER_ID) {
      return new MessageFilter().withUserId(c.value);
    }
    if(c.type === CriteriaType.EMAIL) {
      return new MessageFilter().withEmail(c.value);
    }
    return new MessageFilter();
  }

  withMsisdn(s: string) {
    this.msisdn = s
    return this
  }

  withUserId(s: string) {
    this.userId = s
    return this
  }

  withEmail(s: string) {
    this.email = s
    return this
  }
}
